import { getAuthToken, getParsedUser } from './authStorage';
import { getOrCreateVisitorId } from './referralTracking';

const normalizeUrl = (url) => {
  if (!url) return '';
  return url.replace(/\/+$/, '');
};

const API_BASE_URL = normalizeUrl(process.env.REACT_APP_API_URL);

function snapshotItems(items) {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    productId: String(item?.id || item?._id || ''),
    name: item?.name || '',
    image: item?.image || item?.thumbnail || '',
    urlSlug: item?.urlSlug || '',
    price: item?.price,
    storeName: item?.storeName || '',
    addedAt: item?.addedAt || Date.now(),
  })).filter((item) => item.productId);
}

export async function syncSavedDeals(items) {
  if (!API_BASE_URL) return false;
  const visitorId = getOrCreateVisitorId();
  if (!visitorId) return false;
  const user = getParsedUser();
  const token = getAuthToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  try {
    await fetch(`${API_BASE_URL}/api/saved-deals`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        visitorId,
        items: snapshotItems(items),
        email: user?.email || '',
        phone: user?.phone || '',
        name: user?.name || '',
      }),
      keepalive: true,
    });
    return true;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Saved deals sync failed:', error);
    }
    return false;
  }
}

let saveTimer = null;
export function debouncedSyncSavedDeals(items) {
  if (saveTimer) clearTimeout(saveTimer);
  saveTimer = setTimeout(() => {
    syncSavedDeals(items);
  }, 700);
}
